import type { ABTestClickTracker } from '@/modules/video_new/ab_test_click_tracker';
import type { RecommendationStore } from '@/stores/recommendation/recommendation';
import type { MagicVariables } from '@/types';

import type { VideoPageSiteData } from './types';

export class VideoPage implements MagicVariables {
    $root: MagicVariables['$root'];
    $refs: MagicVariables['$refs'];

    recommendationStore: RecommendationStore;
    siteData: VideoPageSiteData;
    abTestClickTracker: ABTestClickTracker;
    showDescription: boolean = false;

    constructor(
        recommendationStore: RecommendationStore,
        siteData: VideoPageSiteData,
        abTestClickTracker: ABTestClickTracker
    ) {
        this.recommendationStore = recommendationStore;
        this.siteData = siteData;
        this.abTestClickTracker = abTestClickTracker;
        this.storeRecommendationID();
    }

    init() {
        this.abTestClickTracker.init();
    }

    storeRecommendationID() {
        this.recommendationStore.setRecommendationId(this.siteData.recommendationId);
    }
}
